<template>
    <div class=" d-flex justify-content-center align-items-center" style="height:100vh">
        <div class="col-sm-9 col-md-6 col-lg-4 " v-if="status == 'waiting' || status == 'none'">
            <div class="row d-flex justify-content-center" style="font-family:vazir"><h3 >سلام دایی آرش :)</h3></div>
            <div class="row " style="text-align:center"><p class="alert alert-danger w-100">دایی برای دیدن قیمت مقدار را وارد کن </p></div>
                <div class="d-flex justify-content-center">
                    <div>
                     <label for="">مقدار را وارد کنید</label>
                    <div>
                        <input type="text" v-model="amount" class="form-control" placeholder="مثلا 0.1">
                    </div>
                    </div>
                </div>
            <div class="row d-flex justify-content-center mt-4" v-if="amount">

                <button :class="status != 'waiting' ? 'btn btn-success' : 'btn btn-dark btn-disable'" @click="status != 'waiting' ? showFee() : ''"><span v-if="status !='waiting'" >مشاهده قیمت</span> <i v-else class="fa fa-spinner fa-spin"></i></button>
            </div>
        </div>
        <div class="col-sm-9 col-md-6 col-lg-4 " v-else>
            <div class="card">
                <div class="card-header d-flex justify-content-center" style="text-align:center" >قیمت های {{date}}</div>
                <div class="body d-flex justify-content-center">
                    <div class="container d-flex justify-content-center ">
                        <div class="mt-3">
                        <div>
                        <label for=""><i class="fa fa-dollar p-1" style="color:darkgreen"></i> قیمت تتر  :</label>
                        <div style="font-weight:800;float:left">{{Fee.dollar}} تومان</div>
                        </div>
                        <hr>
                        <div class="mt-3">
                        <label for=""> <i class="fa fa-bitcoin"  style="color:gold"></i> قیمت فروش  :</label>
                        <div style="font-weight:800;float:left">{{Fee.sell}} تومان</div>
                        </div>
                        <hr>
                        <div class="mt-3">
                        <label for=""> <i class="fa fa-bitcoin" style="color:gold"></i> قیمت خرید  :</label>
                        <div style="font-weight:800;float:left">{{Fee.buy}} تومان</div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                                    <div>
                     <label for="">مقدار را وارد کنید</label>
                    </div>
                <input type="text" v-model="amount" class="form-control" placeholder="مثلا 0.1">
            </div>
            <div class="d-flex justify-content-center">
                
                <button class="btn btn-dark mt-2" @click="showFee()">گرفتن دوباره قیمت</button>
            </div>
            <div class="row mt-2" style="text-align:center"><p class="alert alert-info w-100">دایی هربار که روی دکمه بالا کلیک کنی قیمت آپدیت میشه </p></div>
            <div class="row " style="text-align:center"><p class="alert alert-success w-100">قیمت زمانی فیکس میشه که من باهاشون  تماس بگیرم</p></div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment-jalaali'
moment.loadPersian({usePersianDigits:true})
export default {
    data(){
        return{
            Fee:{},
            status : 'none',
            date : '',
            amount:""
        }
    },
    methods:{
        async showFee(){
            this.date = moment().format('dddd jDD jMMMM jYY // ساعت : HH:mm:ss'),
            this.Fee = {}
            this.status = 'waiting'
            let res = await axios.get(`http://185.81.96.220/fee.html?amount=${this.amount}`)
            if(res.status == 200){
            this.Fee = res.data
            this.status = 'success'
            }

        }
    }
}
</script>